import { Image } from 'antd'
import React from 'react'
import { View } from 'styles/reactnative'
const AdminEventImages = ({ images }) => {
	const numImages = images?.length

	return (
		<View
			style={{
				width: '100%',
				height: '100%',
				display: 'flex',
				flex: 1,
			}}>
			{numImages === 1 && (
				<View style={{ width: '100%', height: '100%' }}>
					<Image
						style={{ width: '100%', height: '100%', objectFit: 'cover' }}
						alt="event"
						src={images[0]}
					/>
				</View>
			)}
			{numImages > 1 && (
				<View
					style={{
						display: 'grid',
						gridTemplateColumns: `repeat(${Math.min(numImages, 3)}, 1fr)`,
						gap: 6,
						width: '100%',
					}}>
					{images.map((image, index) => (
						<View key={index.toString()} style={{ width: '100%', aspectRatio: '1 / 1' }}>
							<Image
								style={{ width: '100%', height: '100%', objectFit: 'cover' }}
								alt="event"
								src={image}
							/>
						</View>
					))}
				</View>
			)}
		</View>
	)
}
export default AdminEventImages
